import { render, staticRenderFns } from "./appointmentdoctorcenter.vue?vue&type=template&id=7b6de93d&scoped=true"
import script from "./appointmentdoctorcenter.vue?vue&type=script&lang=js"
export * from "./appointmentdoctorcenter.vue?vue&type=script&lang=js"
import style0 from "./appointmentdoctorcenter.vue?vue&type=style&index=0&id=7b6de93d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b6de93d",
  null
  
)

export default component.exports